var archives = {
  cinescatti: {
    slug: 'cinescatti',
    name: 'CineScatti',
    nameBold: 'Cine',
    nameLight: 'Scatti',
    nameMiniParts: { bold: 'C', light: 'SCA' }
  },
  superottimisti: {
    slug: 'superottimisti',
    name: 'Superottimisti',
    nameBold: 'Super',
    nameLight: 'ottimisti',
    nameMiniParts: { bold: 'S', light: 'OTT' }
  }
}

var DEFAULT_ARCHIVE = 'cinescatti'

function getBrandingBySlug (slug) {
  if (!slug) return archives[DEFAULT_ARCHIVE]
  var key = slug.toLowerCase()
  return archives[key] || archives[DEFAULT_ARCHIVE]
}

function getBrandingByArchiveName (archiveName) {
  if (!archiveName) return archives[DEFAULT_ARCHIVE]
  var normalized = archiveName.toLowerCase().replace(/\s+/g, '')
  var keys = Object.keys(archives)
  for (var i = 0; i < keys.length; i++) {
    if (archives[keys[i]].name.toLowerCase().replace(/\s+/g, '') === normalized) {
      return archives[keys[i]]
    }
  }
  return archives[DEFAULT_ARCHIVE]
}

export { archives, DEFAULT_ARCHIVE, getBrandingBySlug, getBrandingByArchiveName }



// WEBPACK FOOTER //
// ./src/config/branding.js